/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_No_MatchesInputs */



/**
* | output |
* | --- |
* | "No matches" |
*
* @param {Chat_Mentions_No_MatchesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_no_matches = /** @type {((inputs?: Chat_Mentions_No_MatchesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_No_MatchesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Treffer")
	return /** @type {LocalizedString} */ ("No matches")
});